<script setup lang="ts"></script>

<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="white" />
    <path
      d="M12.2468 14.8332C12.2468 12.6332 12.2468 11.5332 12.9308 10.8505C13.6135 10.1665 14.7135 10.1665 16.9135 10.1665C19.1135 10.1665 20.2135 10.1665 20.8961 10.8505C21.5801 11.5332 21.5801 12.6332 21.5801 14.8332C21.5801 17.0332 21.5801 18.1332 20.8961 18.8158C20.2135 19.4998 19.1135 19.4998 16.9135 19.4998C14.7135 19.4998 13.6135 19.4998 12.9308 18.8158C12.2468 18.1332 12.2468 17.0332 12.2468 14.8332ZM13.7895 28.3758C15.2601 26.9025 15.9988 26.1665 16.9135 26.1665C17.8281 26.1665 18.5655 26.9025 20.0375 28.3758C21.5108 29.8465 22.2468 30.5852 22.2468 31.4998C22.2468 32.4145 21.5108 33.1518 20.0375 34.6238C18.5668 36.0972 17.8281 36.8332 16.9135 36.8332C15.9988 36.8332 15.2615 36.0972 13.7895 34.6238C12.3161 33.1532 11.5801 32.4145 11.5801 31.4998C11.5801 30.5852 12.3161 29.8478 13.7895 28.3758Z"
      stroke="currentColor"
      stroke-width="2.5"
    />
    <path
      d="M16.9131 19.5V26.1667M22.2465 31.5H28.9131"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.9131 31.4997C28.9131 29.2997 28.9131 28.1997 29.5971 27.517C30.2798 26.833 31.3798 26.833 33.5798 26.833C35.7798 26.833 36.8798 26.833 37.5625 27.517C38.2465 28.1997 38.2465 29.2997 38.2465 31.4997C38.2465 33.6997 38.2465 34.7997 37.5625 35.4823C36.8798 36.1663 35.7798 36.1663 33.5798 36.1663C31.3798 36.1663 30.2798 36.1663 29.5971 35.4823C28.9131 34.7997 28.9131 33.6997 28.9131 31.4997Z"
      stroke="currentColor"
      stroke-width="2.5"
    />
  </svg>
</template>
